import isApiError from "@insite/client-framework/Common/isApiError";
import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { GetNewProductsParameter, GetNewProductsResponseModel } from "@midland-industries/Types/NewProductModels";

const customUrl = "/api/v1/newproducts";

export async function getNewProducts(
    parameter: GetNewProductsParameter,
): Promise<ServiceResult<GetNewProductsResponseModel>> {
    try {
        const paramString = assembleParameters(parameter);
        const url = `${customUrl}${paramString}`;
        const apiResult = await get<GetNewProductsResponseModel>(url);
        return {
            successful: true,
            result: apiResult,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || "An unexpected error occurred while loading new products.",
            };
        }
        throw error;
    }
}

const assembleParameters = (parameter: GetNewProductsParameter): string => {
    let isFirst = true;
    let paramString = "";

    if (parameter.returnCategories) {
        if (isFirst) {
            paramString = `${paramString  }?returncategories=true`;
            isFirst = false;
        } else {
            paramString = `${paramString  }&returncategories=true`;
        }
    }

    if (parameter.returnProductDtos) {
        if (isFirst) {
            paramString = `${paramString  }?returnproductdtos=true`;
            isFirst = false;
        } else {
            paramString = `${paramString  }&returnproductdtos=true`;
        }
    }

    if (parameter.categoryId) {
        if (isFirst) {
            paramString = `${paramString  }?categoryid=${  parameter.categoryId}`;
            isFirst = false;
        } else {
            paramString = `${paramString  }&categoryid=${  parameter.categoryId}`;
        }
    }

    if (parameter.pageSize) {
        if (isFirst) {
            paramString = `${paramString  }?pagesize=${  parameter.pageSize}`;
            isFirst = false;
        } else {
            paramString = `${paramString  }&pagesize=${  parameter.pageSize}`;
        }
    }

    return paramString;
};
